import React from 'react';
import './FormInput.css';

/**
 * Reusable FormInput component for text, email, number, date inputs
 * @param {string} label - Field label
 * @param {string} name - Input name
 * @param {string} type - Input type (text, email, number, date, etc.)
 * @param {string} value - Input value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether field is required
 * @param {string} error - Error message to display
 * @param {number} rows - For textarea, number of rows
 */
const FormInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  required = false,
  error = '',
  rows = 3,
  disabled = false,
  min,
  max,
  step,
}) => {
  const isTextarea = type === 'textarea';
  const InputComponent = isTextarea ? 'textarea' : 'input';

  return (
    <div className="form-input">
      {label && (
        <label htmlFor={name} className="form-input-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <InputComponent
        id={name}
        name={name}
        type={isTextarea ? undefined : type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`form-input-control ${error ? 'error' : ''}`}
        rows={isTextarea ? rows : undefined}
        min={min}
        max={max}
        step={step}
      />
      {error && <span className="form-input-error">{error}</span>}
    </div>
  );
};

export default FormInput;
